import { Typography } from "@mui/material";
import PreisBox, { PreisType } from "./PreisBox";
import SEO from "../seo/SEO";
import "./Preise.css";

export default function Preise() {
  const preise: PreisType[] = [
    {
      leistung: "Osteopathische Erstbehandlung",
      beschreibung:
        "Umfassende Anamnese, Untersuchung und Behandlung zur Lösung von Blockaden, Förderung der Beweglichkeit und Stärkung der Muskulatur.",
      preise: ["140 € zzgl. Anfahrt"],
      dauer: "1,5 - 2 Stunden",
      link: "osteopathie-und-physiotherapie",
    },
    {
      leistung: "Osteopathische Folgehandlung",
      beschreibung:
        "Regelmäßige Behandlung zur Erhaltung der Beweglichkeit und Förderung der langfristigen Gesundheit und Balance des Pferdes.",
      preise: ["110 € zzgl. Anfahrt"],
      dauer: "1 - 1,5 Stunden",
      link: "osteopathie-und-physiotherapie",
    },
    {
      leistung: "Biotensegrales Training",
      beschreibung:
        "Individuelles Training zur Förderung von Balance, Beweglichkeit und Tragfähigkeit auf Basis natürlicher Bewegungsmuster.",
      preise: ["60 € zzgl. Anfahrt"],
      dauer: "45 - 60 Minuten",
      link: "biotensegrales-training",
    },
    {
      leistung: "Blutabnahme und Befundbesprechung",
      beschreibung:
        "Blutabnahme und verständliche Interpretation der Ergebnisse zur Unterstützung der Gesundheit Ihres Pferdes.",
      preise: ["50 € zzgl. Laborgebühren und Anfahrt"],
      dauer: "20 - 30 Minuten",
      link: "blutabnahme-und-befundbesprechung",
    },
    {
      leistung: "Dry Needling",
      beschreibung:
        "Gezielte Behandlung von Muskelverspannungen und Triggerpunkten zur Förderung gesunder Bewegungsabläufe.",
      preise: ["80 € zzgl. Anfahrt"],
      dauer: "30 - 45 Minuten",
      link: "dry-needling",
    },
    {
      leistung: "Akupunktur",
      beschreibung:
        "Individuelle Punktwahl nach ausführlicher Anamnese zur funktionellen Regulation, Schmerzlinderung und Unterstützung von Organfunktionen, Stoffwechsel und Immunsystem.",
      preise: ["60 € zzgl. Anfahrt"],
      dauer: "30 - 45 Minuten",
      link: "akupunktur",
    },
    {
      leistung: "Futterberatung und Rationsberechnung",
      beschreibung:
        "Analyse der aktuellen Fütterung, individuelle Rationsberechnung und Erstellung eines bedarfsgerechten Futterplans.",
      preise: ["110 € zzgl. Anfahrt"],
      dauer: "30 - 60 Minuten",
      link: "futterberatung-und-rationsberechnung",
    },
    {
      leistung: "Hofmag Therapie",
      beschreibung: "Wissenschaftlich geprüfte hochmoderne, gepulste elektromagnetische Magnetfeldtherapie (PEMF)",
      preise: [
        "Schnupperbehandlung: 40 € zzgl. Anfahrt",
        "Verletzungen: 30 € zzgl. Anfahrt",
        "Wellnessbehandlung: 60 € zzgl. Anfahrt",
        "Therapiebehandlung: 80 € zzgl. Anfahrt",
      ],
      link: "hofmag-therapie",
    },
    {
      leistung: "Anfahrtskosten",
      beschreibung:
        "Die Anfahrtskosten sind von der Entfernung und der Fahrtdauer abhängig. Bei mehreren Behandlungen nah beieinander werden die Anfahrtskosten aufgeteilt. Die genaue Berechnung erfolgt auf Anfrage. Ich versuche, durch eine abgestimmt Terminplanung die Anfahrtskosten so gering wie möglich zu halten.",
      preise: [],
    },
    {
      leistung: "Ausfallkosten",
      beschreibung:
        "Es kann immer mal etwas dazwischen kommen. Daher sind Absagen bis 48h vor dem eigentlichen Termin kostenfrei. Danach behalte ich mir vor 80% der Behandlungsgebühr in Rechnung zu stellen. Sollte ein Termin ohne Absage nicht eingehalten werden, berechne ich den vollen Betrag zzgl. Anfahrtskosten.",
      preise: [],
    },
  ];
  return (
    <div id="preise-wrapper">
      <SEO
        title="Preise"
        description="Preise für Osteopathie, Physiotherapie, Biotensegrales Training, Akupunktur, Dry Needling, Hofmag und Futterberatung beim Pferd in Hamburg."
        breadcrumbs={[
          { name: "Start", path: "/" },
          { name: "Preise", path: "/preise" },
        ]}
      />
      <div className="spacing" />
      <div id="preise">
        <Typography align="center" variant="h1">
          Preise
        </Typography>
        <hr style={{ margin: "2% 5%" }} />
        <div className="preise-liste">
          {preise.map((preis) => (
            <PreisBox preis={preis} key={preis.leistung} />
          ))}
        </div>
      </div>
      <div className="spacing" />
    </div>
  );
}
